import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ThemeState {
  primaryColor: string
  isDarkMode: boolean
  borderRadius: number
  setPrimaryColor: (color: string) => void
  setDarkMode: (isDark: boolean) => void
  toggleDarkMode: () => void
  setBorderRadius: (radius: number) => void
  resetTheme: () => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      primaryColor: '#7c3aed',
      isDarkMode: false,
      borderRadius: 6,
      setPrimaryColor: (color: string) => {
        set({ primaryColor: color })
        document.documentElement.style.setProperty('--color-primary', color)
      },
      setDarkMode: (isDark: boolean) => {
        set({ isDarkMode: isDark })
        if (isDark) {
          document.documentElement.classList.add('dark-mode')
        } else {
          document.documentElement.classList.remove('dark-mode')
        }
      },
      toggleDarkMode: () => {
          set((state) => {
              const newMode = !state.isDarkMode
              if (newMode) {
                  document.documentElement.classList.add('dark-mode')
              } else {
                  document.documentElement.classList.remove('dark-mode')
              }
              return { isDarkMode: newMode }
          })
      },
      setBorderRadius: (radius: number) => {
          set({ borderRadius: radius })
          document.documentElement.style.setProperty('--border-radius', `${radius}px`)
      },
      resetTheme: () => {
        set({ primaryColor: '#7c3aed', isDarkMode: false, borderRadius: 6 })
        document.documentElement.style.setProperty('--color-primary', '#7c3aed')
        document.documentElement.style.setProperty('--border-radius', '6px')
        document.documentElement.classList.remove('dark-mode')
      },
    }),
    {
      name: 'admin-theme-storage',
    }
  )
)
